<template>
  <div class="col-lg-4 col-md-4 col-sm-6 col-6 toothbrush" :class="colorClass">
    <div class="title">
      <div v-html="title"></div>
    </div>
    <div>
      <img :src="imgUrl">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    imgUrl: String,
    colorClass: String
  },
  computed: {
  },
  components: {
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .toothbrush {
    min-height: 100px;
    padding: 40px;
    color: $color-white;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    > * {
      flex: 1;
    }
    .title {
      font-size: 48px;
      line-height: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    img {
      padding-top: 15px;
    }

    @media (max-width: $breakpoint-sm) {
      padding: 20px;
      .title {
        font-size: 16px;
      }
      img {
        width: 25px;
        padding-top: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Toothbrush.vue